module.exports = __webpack_public_path__ + "img/Flag_of_Thailand.e7f18a54.svg";